import React from "react";
import clsx from "clsx";
import { Button, ButtonProps } from "@mui/material";
import FiltersArrowsSort from "../../coach-clients/FiltersArrowsSort";
import makeStyles from "@mui/styles/makeStyles";

export enum ProgramTemplateSort {
  NAME_ASC = "NAME_ASC",
  NAME_DESC = "NAME_DESC",
}

interface ProgramNameSortButtonProps extends ButtonProps {
  sortKey: ProgramTemplateSort;
  onChangeSortKey?: (sortKey: ProgramTemplateSort) => void;
}

const useStyles = makeStyles((theme) => ({
  root: {
    fontWeight: "bold",
    fontSize: 15,
    color: theme.palette.text.primary,
  },

  active: {
    color: theme.palette.primary.main,
  },

  inactive: {
    color: theme.palette.text.primary,
  },
}));

export const ProgramNameSortButton = (props: ProgramNameSortButtonProps) => {
  const { sortKey, onChangeSortKey, className, ...other } = props;
  const s = useStyles();
  const isActiveAsc = sortKey === ProgramTemplateSort.NAME_ASC;
  const isActiveDesc = sortKey === ProgramTemplateSort.NAME_DESC;
  const isActive = isActiveAsc || isActiveDesc;
  const handleClick = () => {
    const nextSort =
      sortKey === ProgramTemplateSort.NAME_ASC
        ? ProgramTemplateSort.NAME_DESC
        : ProgramTemplateSort.NAME_ASC;

    onChangeSortKey?.(nextSort);
  };

  return (
    <Button
      className={clsx(s.root, className, {
        [s.active]: isActive,
      })}
      children="Name"
      endIcon={
        <FiltersArrowsSort activeUp={isActiveAsc} activeDown={isActiveDesc} />
      }
      onClick={handleClick}
      {...other}
    />
  );
};
